// Lazy Firebase initialization with fine-grained loaders
let appPromise = null;

const firebaseConfig = {
  apiKey: "AIzaSyCFbnQpFojkm22bF8eB_PXeeUpIgmt6isA",
  authDomain: "road-to-la-defense.firebaseapp.com",
  projectId: "road-to-la-defense",
  storageBucket: "road-to-la-defense.appspot.com",
  messagingSenderId: "123456789",
  appId: "1:123456789:web:xxxxx",
};

export async function getFirebaseApp() {
  if (!appPromise) {
    appPromise = import("firebase/app").then(({ initializeApp }) => initializeApp(firebaseConfig));
  }
  return appPromise;
}

export async function getAuthService() {
  const app = await getFirebaseApp();
  const { getAuth } = await import("firebase/auth");
  return getAuth(app);
}

export async function getFirestoreService() {
  const app = await getFirebaseApp();
  const { getFirestore } = await import("firebase/firestore");
  return getFirestore(app);
}

export async function getFunctionsService() {
  const app = await getFirebaseApp();
  const { getFunctions } = await import("firebase/functions");
  return getFunctions(app);
}

